import React from 'react';
import styled from '@emotion/styled';

import SnsImage from '../../images/Snspic.png';

import PhonelinkRingIcon from '@material-ui/icons/PhonelinkRing';
import { LineIcon,TwitterIcon,FacebookIcon } from 'react-share';
import InstagramIcon from '@material-ui/icons/Instagram';
import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';
import Img from 'gatsby-image';

const TitleBox = styled.div`
    padding:20px;
       h4 {
           margin-top:0;
           margin-bottom:20px;
       }
       h5 {
           color:red;
           text-decoration:underline;
       }
       h2 {
        color : #ffc400;
       }
`;

const SnsSection = styled.section`
    padding-bottom:60px;
    background-color:#f0fafe;
    width:80%;
    max-width:100%;
    display:block;

    @media (max-width:${props => props.theme.breakpoints.md}) {
        width:100%;
        height:100%;
    }
    @media (min-width:${props => props.theme.breakpoints.sm}) {
        display:inline-block;
    }

`;

const SnsContent = styled.div`
    ${'' /* position:relative; */}
    img {
        width:100%;
        max-width:100%;
        height:80%;
        border-radius: 0px 0px 100px 100px;
    }
`;

const SnsGroup = styled.div`
    color:black;
    a {
        margin:40px;
    }
`;

const SNS = () => (
    <SnsSection>
    <SnsContent>
    <SnsGroup>
    <TitleBox>
        <h2><PhonelinkRingIcon color="primary"/>SNS发信息<PhonelinkRingIcon color="secondary"/></h2>
        <p>优惠价还有其他料理信息</p>
        <h4>看看SNS来关注店</h4>
    </TitleBox>
        <Grid
            container
            direction="row"
            justify="center"
            alignItems="center"
            style={{marginBottom:"30px"}}
            >
        <Grid  item xs={6} style={{margin:"10px 0px"}}>
        <a href="https://www.facebook.com/%E6%A0%AA%E5%BC%8F%E4%BC%9A%E7%A4%BE%E3%82%B9%E3%83%9E%E3%83%BC%E3%83%88%E3%83%96%E3%83%A9%E3%82%A4%E3%83%80%E3%83%AB%E3%82%AF%E3%83%A9%E3%83%96-113011107127656">
            <FacebookIcon size={60} />
        </a>
        </Grid>
        <Grid item xs={6}>
        <a href="https://twitter.com/smbcparty">
            <TwitterIcon size={60} />
        </a>
        </Grid>
        <Grid item xs={6}>
        <a href="https://www.instagram.com/smart_bridal_club/">
            <InstagramIcon style={{backgroundColor:"#de306e",color:"white",width:"60px",height:"60px"}} />
        </a>
        </Grid>
        <Grid item xs={6}>
        <a href="/404">
            <LineIcon size={60} />
        </a>
        </Grid>
        </Grid>
    </SnsGroup>
</SnsContent>
<Divider variant="middle" />
</SnsSection>
)

export default SNS;



